// extracted by mini-css-extract-plugin
module.exports = {"logo":"_7a3fb80146--logo--e0PEF","link":"_7a3fb80146--link--liFPD","label":"_7a3fb80146--label--WcnVE"};